export const PORT_CURRENT_FLOW_REFRESH_MS = 60 * 1000;

// Poll only the prepared endpoint: page requests never download NOAA fields.
export function watchPortCurrentFlow({ load, render, unavailable, document, window }) {
  let view = null;
  let version = null;
  let pending = false;
  let stopped = false;

  async function refresh() {
    if (pending || stopped || document.hidden) return;
    pending = true;
    try {
      const payload = await load();
      if (stopped) return;
      if (!payload?.available) throw new Error("Current field is unavailable");
      const nextVersion = JSON.stringify([
        payload.dataVersion || payload.generatedEpoch || payload,
        payload.validTime,
        payload.portLocation, payload.samplingLocation,
      ]);
      if (nextVersion !== version) {
        if (view) view.update(payload);
        else view = render(payload);
        version = nextVersion;
      }
      view.status(payload);
    } catch {
      if (!stopped) unavailable(Boolean(view));
    } finally {
      pending = false;
    }
  }

  const timer = window.setInterval(refresh, PORT_CURRENT_FLOW_REFRESH_MS);
  document.addEventListener("visibilitychange", refresh);
  window.addEventListener("pageshow", refresh);
  const stop = () => {
    stopped = true;
    window.clearInterval(timer);
    document.removeEventListener("visibilitychange", refresh);
    window.removeEventListener("pageshow", refresh);
    window.removeEventListener("pagehide", pagehide);
    view?.remove();
  };
  // Keep the watcher alive when the browser stores this page in its back/forward cache.
  const pagehide = (event) => { if (!event.persisted) stop(); };
  window.addEventListener("pagehide", pagehide);
  refresh();
  return { refresh, stop };
}
